// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-container[data-v-693f1fc1]{display:block;padding-left:10px}.invisible[data-v-693f1fc1]{display:none}#fieldRoles[data-v-693f1fc1]{display:inline-block}.seatsWarning[data-v-693f1fc1]{color:#f60;margin-left:10px;display:inline-block}.noLicensesWarning[data-v-693f1fc1]{color:#ff3b1d;font-size:0.9em;font-style:italic}#createEditUser[data-v-693f1fc1]{padding:0px 30px}\n", ""]);
// Exports
module.exports = exports;
